import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

/**
 * Stores the start value for query results fetching after histogram zoom.
 * This is an ISO timestamp string that gets passed to the API's startValue parameter.
 * When set, triggers a query refetch from the specified timestamp.
 * Scoped by tab ID.
 */
export const queryStartValueAtomFamily = atomFamily(() =>
  atom<string | null>(null),
);
